import { CommonModule, DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbActiveModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { OpenStatementsComponent } from './open-statements/open-statements.component';
import { FormatNegativeValuePipe } from './statement-display/format-negative-value.pipe';
import { StatementDisplayComponent } from './statement-display/statement-display.component';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { SpinnerModule } from '@spartacus/storefront';
import { StatementsPdfDownloadComponent } from './statements-pdf-download/statements-pdf-download.component';
import { translationChunksConfig } from '@spartacus/assets';
import { StatementsListComponent } from './statements-list/statements-list.component';

@NgModule({
  declarations: [
    OpenStatementsComponent,
    StatementDisplayComponent,
    FormatNegativeValuePipe,
  ],
	imports: [
		CommonModule,
		RouterModule,
		I18nModule,
		NgbModule,
		ConfigModule.withConfig({
			cmsComponents: {
				StatementTopBodyComponent: {
					component: () =>
						import('./open-statements/open-statements.component').then(
							(m) => m.OpenStatementsComponent
						)
				}
			},
			i18n: {
				backend: { loadPath: 'i18n-assets/{{lng}}/{{ns}}.json' }
			},
			chunks: translationChunksConfig
		} as CmsConfig),
		FaIconComponent,
		SpinnerModule,
		StatementsPdfDownloadComponent,
		StatementsListComponent
	],
  providers: [NgbActiveModal, DecimalPipe, FormatNegativeValuePipe],
  exports: [OpenStatementsComponent, StatementDisplayComponent],
})
export class StatementsModule {}
